module.exports = __webpack_public_path__ + "img/Tanzania.95b6e852.png";